import React from 'react'
import PropTypes from "prop-types"
import { isArray } from 'lodash'
import { browserHistory } from 'react-router'
import { connect } from 'react-redux'


import {
  Glyphicon, Label, ButtonToolbar,
  Tooltip, OverlayTrigger, Checkbox, Modal
} from "react-bootstrap"

import * as RouteActions from '../../ducks/routes'
import Button from '../../components/Button.jsx'
import { getText } from '../../lib/text.js'

import { getStyle } from './ItemTemplate.styles.js'
import { CutePriceTag } from '../../components/Price'
import Warning from "./Warning"

import "./AgendaItem.less"

/**
 *
 */



// TODO add overlays to the item buttons
const ItemButtons = props => {
  const {
    mode, item, i, routeId, selected, onEdit, remove, repeatExpense, priceValue,
  } = props

  return (
    ((mode == "order")
      && (
        <ButtonToolbar>
          <CutePriceTag
            priceValue={priceValue}
            style={{ float: "left", marginLeft: 5 }}
          />

          {
            props.onInfo && (
              <Button glyph="info-sign" tooltipText="Ver info" bsSize="xsmall" onClick={() => props.onInfo()} />
            )
          }

          {
            item.type == "expense" && (
              <Button bsSize="xsmall" tooltipText="Repetir" onClick={() => repeatExpense(routeId, i)} style={{ float: "left" }}>+1</Button>
            )
          }

          <Button
            tooltipText="Editar detalles"
            bsSize="xsmall"
            onClick={() => onEdit(item.key)}
            glyph="pencil"
            style={{
              float: "left",
              color: (item.useCustomFee || item.useCustomPrice)
                ? "blue"
                : ""
            }}
          />

          <Button bsSize="xsmall" tooltipText="Eliminar" onClick={remove} glyph={"remove"} style={{ float: "left" }} />
        </ButtonToolbar>
      ))
    || ((mode == "multi" && item.type == "day")
      && (<Checkbox checked={selected} onChange={() => {}} />))
    || (<span />)
  )
}

/**
 *
 */

class ItemTemplate extends React.PureComponent {
  constructor(props) {
    super(props)
    this.state = {
      modal: "",
      dayToDelete: ""
    }

    this.dayRemove = this.dayRemove.bind(this);
  }

  dayRemove(){
    const {item, remove, routeId, i} = this.props
    if(item.type == "day") this.setState({ modal: "removeDay", dayToDelete: i })
    else remove(routeId, i)
  }

  render() {
    const { item, mode, Activities, routeId, i, selected, 
            repeatExpense, onStartEdit, onInfo, itemInTemplate, priceValue, 
            isDayHovered, isPlaceHolder, dragging, select, onMouseEnter, 
            daysCounter, editingKey, modal, disableTitleLine, icon, title, 
            repetitionLabel, subtitle, warning, compact, description, remove } = this.props

    const wrapperStyle = getStyle(
      item.type,
      isDayHovered,
      item.city,
      selected,
      isPlaceHolder,
      dragging
    )

    return (
      <div
        className="AgendaItem"
        style={wrapperStyle}
        onClick={() => (mode == "multi" && item.type == "day" && select(item, !selected))}
        onMouseEnter={() => onMouseEnter(item, daysCounter)}
      >
        {
          editingKey && editingKey == item.key && modal()
        }
        <div className="innerWrapper">
          <div className="itemTitle">
            {
              !disableTitleLine && (
                <h1>
                  <Glyphicon glyph={icon} />
                  <span>
                    <span>{title}</span>
                    <em>{repetitionLabel || ""}</em>
                    <span className="subtitle">
                      { subtitle }
                    </span>
                  </span>
                  {
                    !isPlaceHolder && item.type == "activity" && (
                      <Button
                        bsSize="xsmall"
                        onClick={() => { browserHistory.push(`/private/activity/${encodeURIComponent(Activities[item.id]._id)}?`) }}
                        glyph={"link"}
                      />
                    )
                  }
                </h1>
              )
            }
            {
              warning && <div><Warning warning={JSON.parse(warning)} /></div>
            }
          </div>
          
          <div style={{maxWidth: "80%", marginLeft: "1%", overflow: "hidden"}}>
            {!compact ? description : ""}
          </div>
          <div style={getStyle("buttonGrp", isDayHovered)}>
            <ItemButtons
              mode={mode}
              item={item}
              i={i}
              routeId={routeId}
              Activities = {Activities}
              selected={selected}
              remove={this.dayRemove}
              repeatExpense={repeatExpense}
              onEdit={onStartEdit}
              onInfo={onInfo}
              itemInTemplate={!!itemInTemplate}
              priceValue={priceValue}
            />
          </div>
        </div>
        {
            this.state.modal == "removeDay" && (
              <Modal show onHide={() => this.setState({ modal: "" })}>
                <Modal.Header>
                  <Modal.Title>
                    {getText("Borrar día")}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {getText("¿Desea borrar tambien todos los items del dia?")}
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    bsStyle="danger"
                    onClick={() => {
                      remove(routeId, i, true)
                      this.setState({ modal: "" })
                    }}
                    label={getText("Si")}
                  />
                  <Button
                    bsStyle="success"
                    onClick={() => {
                      remove(routeId, i)
                      this.setState({ modal: "" })
                    }}
                    label={getText("No")}
                  />
                  <Button onClick={() => this.setState({ modal: "" })} label={getText("Cancelar")} />
                </Modal.Footer>
              </Modal>
            )
          }
      </div>
    )
  }
}

ItemTemplate.propTypes = {
  title: PropTypes.any.isRequired,
  subtitle: PropTypes.any.isRequired,
  compact: PropTypes.bool.isRequired,
  icon: PropTypes.string.isRequired,

  remove: PropTypes.string, // not required: doesn't appear while adding
  onInfo: PropTypes.string.isRequired,
  priceValue: PropTypes.any.isRequired,
    
  repeatExpense: PropTypes.string,
  description: PropTypes.any,
  disableTitleLine: PropTypes.bool,
  repetitionLabel: PropTypes.any,
  modal: PropTypes.any,
}

export default ItemTemplate